// helpers
import { statusRecipes } from "../../utils/helpers";
import UserLoading from "../Loading";

// components
import AdminStatusItem from "./AdminStatusItem";

const AdminRejected = ({ recipes, loading }) => {
  const rejected = statusRecipes(recipes, "rejected");

  return (
    <div className='admin-wrapper'>
      <h4 className='font-weight-bold'>Rejected Recipes</h4>
      {loading ? (
        <div className='loading-wrapper'>
          <UserLoading />
        </div>
      ) : rejected.length > 0 ? (
        rejected.map((item, index) => {
          return <AdminStatusItem key={index} data={item} status='rejected' />;
        })
      ) : (
        <div className='recipes-empty'>
          <h5>No recipes to show!</h5>
        </div>
      )}
    </div>
  );
};

export default AdminRejected;
